module.exports = __webpack_public_path__ + "ce6f6bbdb7b3b68f4666b6d40a3f8abc.MP3";